<div *ngIf="subMenuItems().length > 0" class="w-full ml-4">
  <!-- <div class="flex items-center space-x-1 bg-white/60 rounded-lg p-1 overflow-x-auto tab-scroll min-h-0 min-w-0"> -->
  <div class="ml-25 flex items-center space-x-1 bg-white/60 rounded-lg p-1 overflow-x-auto tab-scroll min-h-0 min-w-0">

    <ng-container *ngFor="let item of subMenuItems()">
      <a
        *ngIf="checkPermission(item.privileges)"
        href="javascript:void(0)"
        (click)="onSubMenuClick(item)"
        class="flex items-center px-2 py-1 text-xs rounded-md font-medium cursor-pointer select-none transition-all duration-200
          border border-transparent whitespace-nowrap
          "
        [ngClass]="{
          'bg-blue-600 text-white shadow-md scale-105 z-10': item.active,
          'bg-white/40 text-slate-800 hover:bg-blue-100 z-0': !item.active
        }"
        role="tab"
        tabindex="0"
        [attr.aria-selected]="item.active"
      >
        <i *ngIf="item.icon" class="{{item.icon}} mr-1 text-xs opacity-70"></i>
        <span class="z-10">{{ item.name }}</span>
      </a>
    </ng-container>
  </div>
</div>